<template> 
  <div> 
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Assignment & Vehicle Movement Tracking</b-navbar-brand>

          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-navbar>

        <md-layout md-gutter>
          <md-layout md-flex="35">
            <date-range-picker
            class="mr-2"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
            ></date-range-picker>
          </md-layout>
          <!-- <md-layout md-flex="5" /> -->
          <md-layout md-flex="50">
            <b-form-input
              :formatter="capitalizeAll"
              v-model="filter"
              placeholder="Search Assignment No. / Client Name / Container No. /Vehicle No /GRN No./Booking No."
              @input="debounceSearch"
            ></b-form-input>
          </md-layout>
          <md-layout md-flex="15">
            <model-list-select
                @input="viewAssignment('0', '1', '1')"
                :list="dateStatusList"
                v-model="dateStatusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Date Filter"
              ></model-list-select>
          </md-layout>
        </md-layout>
        <b-row>
         <b-col md="3">
            <label>Vehicle Status</label>
            <model-list-select :list="VehicleStatusList" v-model="vehicleStatusFilter" 
              option-value="val" option-text="status" placeholder="Select Vehicle Status"
              @input="viewAssignment('0', '1', '1')"
              />
          </b-col>
        </b-row>
        <div>
          <h5 class="text-muted pull-right mt-2">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <b-row>
          <b-col>
            <b-button
              v-if="dateRange.endDate !='' && dateRange.startDate !=''"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              class="pull-right ml-1 mt-1"
              @click="getReports('GPS_GRN_LIST_EXCEL')"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>
          <b-col>
            <!-- Client-side Export using xlsx -->
            <b-button
              v-if="veiwVehicleBookingForm.length > 0"
              class="pull-right ml-1 mt-1"
              @click="exportToExcelClient"
              size="sm"
              variant="success"
              >
              Export (Client XLSX)
            </b-button>
            <b-button
              v-if="veiwVehicleBookingForm.length > 0"
              class="pull-right ml-1 mt-1"
              @click="exportOfBuyingRateToExcelClient"
              size="sm"
              variant="success"
              >
              OF Rate Export (Client XLSX)
            </b-button>
          </b-col>
        </b-row>
        <div class="table-responsive tableMain mt-2">
          <b-table
            show-empty
            stacked="md"
            :items="veiwVehicleBookingForm"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="quotationId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="salesSeries" slot-scope="row1">
              <b
                @click="
                  viewAssignmentpage(
                    row1.item.clientId,
                    row1.item.salesBookingId,
                    row1.item.quotationId,
                    row1.item.assignId
                  )
                "
                class="showMoreData"
              >
                Assignment No. : {{ row1.item.assignSeries.split(",")[0] }}
                <br />
              </b>
              <!-- @click="viewAssignmentpage(row1.item.clientId,row1.item.salesBookingId,row1.item.quotationId,row1.item.assignId)"
              class="showMoreData"-->
              <span>Execution No. : {{ row1.item.salesSeries }}</span>
              <br />
              <br />
              <a>
                <b-button
                  variant="outline-success"
                  size="sm"
                  @click="goToTrack(row1.item.assignId)"
                  >Track Assignment</b-button
                >
              </a>
              <br />
              <br />

              <b-button size="sm" @click="showDocModal(row1.item)" variant="outline-dark"
                >Summary & Documents</b-button
              >
              <Assignment-Summary
                :title="'Shipment Summary Tracking - '"
                :fk_all_module_id="row1.item.allModuleId"
                :jb_series="row1.item.salesSeries"
              />
               <ContainerSummary
                v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.salesSeries"
                :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.salesSeries"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.salesSeries"
                  /> -->
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row1.item.allModuleId"
                :jb_series="row1.item.salesSeries" />
                <MSDeleteRequest
                :item="row1.item"
                :JobNo="row1.item.salesSeries"
                :JobID="row1.item.allModuleId"
                :sessionsStorage="$sessionsStorage"
                @refreshData="handleRefresh"
              />
              <b v-if="row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null">Requested By : {{ row1.item.deleteRequestBy }}<br/></b>
              <b v-if="row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null">Arroved By : {{ row1.item.deleteArrovedBy }}<br/></b>
              
              <!-- <span>Raised Frome:\Microsoft VS Code\resources\app\out\vs\code\electron-sandbox\workbench\workbench.html : {{row1.item.EmpLoc}}</span> -->
            </template>

            <template slot="ContainerNo" slot-scope="row3">
              <!-- {{row3.item}} -->
              <div v-if="row3.item.ContainerNo != null">
                <span
                  v-for="(item, index) in row3.item.ContainerNo.split(',')"
                  :key="index"
                >
                  <h6>
                    <b-badge variant="light">{{ item + " " }}</b-badge>
                  </h6>
                </span>
              </div>
            </template>
            <template slot="vehicleNO" slot-scope="row2">
              <span>Vehicle Required : {{ row2.item.noOfTrucks }}</span>
              <br />
              <span>Booked Vehicle : {{ row2.item.vehicleNO }}</span>
            </template>
            <template slot="GRNCount" slot-scope="row5">
              <span>
                {{ row5.item.GRNCount }}
                <br />
              </span>
              <span>
                {{ row5.item.GRNSeries }}
                <br />
              </span>

              <!--  -->

              <Add-Message
                :fk_all_module_id="row5.item.allModuleId"
                :fk_client_id="row5.item.clientId"
                :fk_pod_id="row5.item.PODLocationId"
                style="list-style-type: none"
              />
            </template>
          </b-table>
        </div>
        <div>
          <h5>
            <b-pagination
              limit="5"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </h5>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../../helper/collection";
import DocForm from "../../allModuleForm/docLibrary.vue";
import AddMessage from "../../allModuleForm/addMessage.vue";
import AssignmentSummary from "../../common/assignmentSummary.vue";
import CommonService from "../../../services/CommonService.js";
import DateRangePicker from "vue2-daterange-picker";
import "vue-loading-overlay/dist/vue-loading.css";
import ContainerSummary from "../../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../../common/jobWisePaymentsDetails.vue";
import MSDeleteRequest from "../../common/MSDeleteRequest.vue";
import { exportGRNListToExcel, exportOFRateJobListToExcel } from "../../../helper/ExcelExportHelper";
import * as XLSX from "xlsx";
import TrasportService from "../../../services/TrasportService.js";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/listView/viewAssignmentOrder");
      this.$sessionsStorage.set(
        "PermissionStatus",
        globalPermissionStatus("QuotationAssignment")
      );
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewAssignment("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      vehicleStatusFilter: "3",
      VehicleStatusList: [
        {
          status: "IN TRANSIT",
          val: "1",
        },
        {
          status: "CLOSED",
          val: "2",
        },
        {
          status: "ALL",
          val: "3",
        },
      ],
      fields: [
        {
          key: "quotationId",
          mainkey: "quotationId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "salesSeries",
          mainkey: "salesSeries",
          label: "Execution No.",
          sortable: true,
          sortDirection: "ASC",
          // table: "P."
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          width: "500px",
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "PICK",
          mainkey: "PICK",
          label: "Pickup Location",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },

        {
          key: "STUFF",
          mainkey: "STUFF",
          label: "Factory Location",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "HAND",
          mainkey: "HAND",
          label: "Handover Location",
          sortable: true,
          sortDirection: "ASC",
          //table: "B."
        },
        {
          key: "bookingNo",
          mainkey: "bookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          //table: "B."
        },
        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "ASC",
          //   table: "D."
        },
        {
          key: "vehicleNO",
          mainkey: "vehicleNO",
          label: "Vehicle Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "GRNCount",
          mainkey: "GRNCount",
          label: "No.of GR Generated",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "assignId",
        //   mainkey: "assignId",
        //   label: "Track Assignment",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],

      selectDateFormat,
      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      ExcelBtnName: "Export As Excel",

      NoOfAssignment: "",
      isLoading: false,
      debounce: null,
      viewAssignment1: [],
      veiwVehicleBookingForm: [],
      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
    DocForm,
    AddMessage,
    AssignmentSummary,
    DateRangePicker,
    ContainerSummary,
    AssignmentSplitMergeSummary,
    JobWisePaymentsDetails,
    MSDeleteRequest,
  },
  computed: {},

  methods: {
    getReports(id) {
   
      let payload = {
        itemCode: id,
        dateRange: this.dateRange,
        dateStatusFilter: this.dateStatusFilter,
        type: "Excel",
      };
      this.ExcelBtnName = "Downloading Please Wait .....";
      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewAssignment("0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.salesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewAssignment(CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewAssignment(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    viewVBookingPage(clientId, salesid, quotationId, assignId, vBookingId, followUpId) {
      this.$sessionsStorage.set("clientId", clientId);
      this.$sessionsStorage.set("salesBookingId", salesid);
      this.$sessionsStorage.set("storeQuotationId", quotationId);
      this.$sessionsStorage.set("storeAssignId", assignId);
      this.$sessionsStorage.set("storeVehicleBookingId", vBookingId);
      if (followUpId == "" || followUpId == null) {
        this.$sessionsStorage.set("storefollowActivityId", "false");
      } else {
        this.$sessionsStorage.set("storefollowActivityId", followUpId);
      }

      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },
    goToTrack(AId) {
      this.$sessionsStorage.set("storeAssignId", AId);
      this.$sessionsStorage.set("backToDetailPage", "22");
      this.$router.push({
        path: "/vehicleQuotation/tranportMailDetails",
      });
    },
    goToMain() {
      this.$router.push({
        path: "/sales/salesBooking",
      });
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    JqueryFun() {
      return $(function () {
        return $("#viewVehicleBooking21212").DataTable();
      });
    },

    viewAssignmentpage(clientId, salesid, quotationId, assignId) {
      this.$sessionsStorage.set("storeAssignId", assignId);
      this.$sessionsStorage.set("clientId", clientId);
      this.$sessionsStorage.set("salesBookingId", salesid);
      this.$sessionsStorage.set("storeQuotationId", quotationId);
      this.$router.push({
        path: "/vehicle/vehicleBooking",
      });
    },
    handleRefresh() {
      this.viewAssignment("0", "1", "1");
    },
    viewAssignment(CURRENT, SEARCH, pageNumber) {
      this.doLoading();
      let view_Assignment = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        dateStatusFilter: this.dateStatusFilter,
        assignmentNo: "assignmentNo",
        vehicleStatusFilter: this.vehicleStatusFilter,
      };
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewAssignmentDetail.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // if (data.Assignment.length > 0) {
            //   this.viewAssignment1 = data.Assignment;
            // }
            this.JqueryFun();
            if (data.booking.length > 0) {
              this.veiwVehicleBookingForm = data.booking;
            }
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    async exportToExcelClient() {
      try {
        this.isLoading = true;
        
        // Call the new API to get GRN list data
        const payload = {
          dateRange: {
            startDate: "",
            endDate:  "",
          },
          isAll: 1,
          page: 1,
          pageSize: 10000, // Get all records
        };
        
        const response = await TrasportService.getGRNListNew(payload);
        
        if (response.status === 200 && response.data && response.data.success) {
          const grnList = response.data.data || [];
          
          if (grnList.length > 0) {
            const fileName = `GRN_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            exportGRNListToExcel(grnList, fileName);
            
            this.isLoading = false;
          } else {
            this.isLoading = false;
            alert('No data available to export');
          }
        } else {
          this.isLoading = false;
          alert('Failed to fetch GRN data');
        }
      } catch (error) {
        console.error('Excel export error:', error);
        this.isLoading = false;
        alert('Failed to export Excel file');
      }
    },
    async exportOfBuyingRateToExcelClient() {
      try {
        this.isLoading = true;
        
        // Call the new API to get GRN list data
        const payload = {
          dateRange: {
            startDate: "",
            endDate:  "",
          },
          isAll: 1,
          page: 1,
          pageSize: 10000, // Get all records
        };
        
        const response = await TrasportService.getOfRateList(payload);
        
        if (response.status === 200 && response.data && response.data.success) {
          const grnList = response.data.data || [];
          
          if (grnList.length > 0) {
            const fileName = `OF_Rate_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            exportOFRateJobListToExcel(grnList, fileName);
            
            this.isLoading = false;
          } else {
            this.isLoading = false;
            alert('No data available to export');
          }
        } else {
          this.isLoading = false;
          alert('Failed to fetch GRN data');
        }
      } catch (error) {
        console.error('Excel export error:', error);
        this.isLoading = false;
        alert('Failed to export Excel file');
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewSalesBooking.vue?dbc56fe0